import React from 'react';
import classNames from 'classnames';
import NoImageSVG from 'serp-files/images/no-image.svg';
import { useSERPState } from '~/core/state/SERPStateContext';
import { useProductContext } from './productResultContext';
import ProductResultImageLabels from './ProductResultImageLabels';

const ProductResultImage: React.FC = () => {
    const { result, style, customColorsConfiguration } = useProductContext();
    const state = useSERPState();
    const labelsConfiguration = customColorsConfiguration.labels;

    return (
        <div
            className={classNames(style.serpProductImage, {
                [style.inRows]: state.resultLayout === 'rows',
            })}
        >
            <ProductResultImageLabels items={result.labels} configuration={labelsConfiguration} />
            {result.image !== undefined && (
                <img
                    src={'' !== result.image ? result.image : NoImageSVG}
                    data-testid="product-result-card-img"
                    alt={result.title}
                />
            )}
        </div>
    );
};

export default ProductResultImage;
